import { useEffect } from "react";
import { useJourneyStore } from "../game/state/journeyMachine";

/** Aplica la escala tipográfica global vía variable CSS. */
export function useFontScaleSync(): void {
  const fontScale = useJourneyStore((s) => s.fontScale);
  useEffect(() => {
    document.documentElement.style.setProperty("--cale-font-scale", String(fontScale));
  }, [fontScale]);
}

export function FontScaleControl() {
  const fontScale = useJourneyStore((s) => s.fontScale);
  const setFontScale = useJourneyStore((s) => s.setFontScale);

  return (
    <label className="flex items-center gap-2 text-sm">
      Tamaño de texto
      <input
        type="range"
        min={0.85}
        max={1.5}
        step={0.05}
        value={fontScale}
        onChange={(e) => setFontScale(Number(e.target.value))}
        aria-valuetext={`${Math.round(fontScale * 100)}%`}
        className="w-28 accent-[var(--cale-accent)]"
      />
      <span className="w-12 text-[var(--cale-ink-muted)]">{Math.round(fontScale * 100)}%</span>
    </label>
  );
}
